export const parseMembershipMonthlySharePeriod = (sourceId) => {
  if (!sourceId) return null;
  const parts = String(sourceId).split(':');
  if (parts.length < 3) return null;
  const match = parts[1].match(/^(\d{4})-(\d{2})$/);
  if (!match) return null;
  return { year: Number(match[1]), month: Number(match[2]) };
};

export const collectMembershipPotPeriods = (membershipReport) => {
  const byKey = new Map();

  (membershipReport?.members || []).forEach((member) => {
    (member.breakdown || []).forEach((line) => {
      const period = line.referenceCalendarYear && line.referenceCalendarMonth
        ? { year: line.referenceCalendarYear, month: line.referenceCalendarMonth }
        : parseMembershipMonthlySharePeriod(line.sourceId);

      if (!period?.year || !period?.month) {
        return;
      }

      const key = `${period.year}-${String(period.month).padStart(2, '0')}`;
      const existing = byKey.get(key);
      if (!existing) {
        byKey.set(key, {
          year: period.year,
          month: period.month,
          recognitionDate: line.recognitionDate || null,
          estimated: line.status === 'provisional',
        });
        return;
      }

      if (!existing.recognitionDate && line.recognitionDate) {
        existing.recognitionDate = line.recognitionDate;
      }
      if (line.status === 'provisional') {
        existing.estimated = true;
      }
    });
  });

  return [...byKey.values()].sort((a, b) => a.year - b.year || a.month - b.month);
};
